module.exports = __webpack_public_path__ + "img/img22.e97b5ef5.svg";